import { Tag } from 'antd';
import type { Produto } from '@/features/produto/types/Produto';
import { numberToCurrency } from '@/std/format';
import { ProdutoFavoritoIcone } from './ProdutoFavoritoIcone';

export function ProdutoOption({ produto }: { produto: Produto }) {
    const temPacote =
        Array.isArray(produto.produto_pacote_barra) && produto.produto_pacote_barra.length > 0;

    const temLote = Array.isArray(produto.lote) && produto.lote.length > 0;

    const preco = produto.tabela_preco
        ? produto.tabela_preco.preco_calculado
        : produto.pro_preco_venda;

    return (
        <div className='flex items-center justify-between gap-2 whitespace-normal'>
            <div>
                <div className='flex items-center gap-1'>
                    <ProdutoFavoritoIcone pro_favorito={produto.pro_favorito} />
                    <span className='font-bold'>{produto.pro_descricao}</span>
                </div>

                <div className='text-sm text-gray-700'>
                    <div>Código: {produto.pro_codigo_interno}</div>
                    {produto.pro_cod_barra ? <div>Barras: {produto.pro_cod_barra}</div> : null}
                    {produto.pro_sku ? <div>SKU: {produto.pro_sku}</div> : null}
                    {produto.produto_marca ? (
                        <div>Marca: {produto.produto_marca.prm_descricao}</div>
                    ) : null}
                    <div>
                        Estoque: {produto.estoque_total} {produto.produto_unidade?.pru_sigla}
                    </div>
                    {temPacote ? null : <div>Preço: {numberToCurrency(preco)}</div>}
                </div>
            </div>

            {temPacote || temLote ? (
                <div className='flex flex-col items-end gap-1'>
                    {temPacote && (
                        <Tag color='green' variant='outlined'>
                            Pacote / Barra
                        </Tag>
                    )}

                    {temLote && (
                        <Tag color='blue' variant='outlined'>
                            Lote
                        </Tag>
                    )}
                </div>
            ) : null}
        </div>
    );
}
